import axios from "axios";
import axiosClient from "./axiosClient";

function toApiErrorPayload(error) {
  if (error?.isRefreshNetworkError || !error?.response) {
    return {
      Status: {
        isNetworkError: true,
        code: error?.code,
        message: error?.message,
      },
    };
  }

  return { Status: error.response };
}

export const GET_MYAPI_NOT_TOKEN = (url, handleData) => {
  axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      handleData({ Status: "success", Response: res });
    })
    .catch(function (error) {
      handleData({ Status: "fail", Response: error.response });
    });
};

export const GET_MYAPI_WITH_CREDENTIALS = (url, handleData) => {
  axiosClient
    .get(url, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
    .then((res) => {
      handleData(res.data);
    })
    .catch(function (error) {
      handleData(toApiErrorPayload(error));
    });
};

export const POST_MYAPI_WITH_CREDENTIALS = (url, data, handleData) => {
  axiosClient
    .post(url, data ?? {}, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
    .then((res) => {
      handleData(res.data);
    })
    .catch(function (error) {
      handleData(toApiErrorPayload(error));
    });
};
